import type {
  Pais,
  TipoIdentificacion,
} from "@/lib/api/datosGenerales/types/solicitudInformacion";

// Lista de países con IDs para el formulario
export const PAISES: Pais[] = [
  { id: "PAN", nombre: "Panamá" },
  { id: "USA", nombre: "Estados Unidos" },
  { id: "MEX", nombre: "México" },
  { id: "COL", nombre: "Colombia" },
  { id: "CRI", nombre: "Costa Rica" },
  { id: "ESP", nombre: "España" },
  { id: "ARG", nombre: "Argentina" },
  { id: "BRA", nombre: "Brasil" },
  { id: "CHL", nombre: "Chile" },
  { id: "PER", nombre: "Perú" },
  { id: "ECU", nombre: "Ecuador" },
  { id: "VEN", nombre: "Venezuela" },
  { id: "GTM", nombre: "Guatemala" },
  { id: "HND", nombre: "Honduras" },
  { id: "SLV", nombre: "El Salvador" },
  { id: "NIC", nombre: "Nicaragua" },
  { id: "DOM", nombre: "República Dominicana" },
  { id: "CUB", nombre: "Cuba" },
  { id: "PRI", nombre: "Puerto Rico" },
  { id: "CAN", nombre: "Canadá" },
  { id: "GBR", nombre: "Reino Unido" },
  { id: "FRA", nombre: "Francia" },
  { id: "DEU", nombre: "Alemania" },
  { id: "ITA", nombre: "Italia" },
  { id: "PRT", nombre: "Portugal" },
  { id: "OTR", nombre: "Otro" },
];

// Tipos de identificación disponibles
export const TIPOS_IDENTIFICACION: TipoIdentificacion[] = [
  { value: "cedula", label: "Cédula" },
  { value: "pasaporte", label: "Pasaporte" },
  { value: "ruc", label: "RUC" },
  { value: "otro", label: "Otro" },
];
